// Addresses of the standalone web pages the SPA shell renders instead of the
// main UI (see main.tsx). No menu links to them: whoever needs one is told.

/** Access tokens for Excel / Power Query. */
export const DATA_TOKEN_PAGE_PATH = "/authtoken";
/** The Excel data query builder. */
export const EXCEL_QUERY_PAGE_PATH = "/exceldata";

const atPath = (pathname: string, path: string) => pathname.replace(/\/+$/, "") === path;

/** True on the access-token page (trailing slash allowed). */
export const isDataTokenPage = (pathname: string) => atPath(pathname, DATA_TOKEN_PAGE_PATH);
/** True on the Excel query page (trailing slash allowed). */
export const isExcelQueryPage = (pathname: string) => atPath(pathname, EXCEL_QUERY_PAGE_PATH);
